import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCommonModule } from '@angular/material/core';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { AttachmentsModule } from '@flyfreely-portal-ui/attachments';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FlyFreelyTableModule } from '@flyfreely-portal-ui/flyfreely-table';
import { LoadingIndicatorModule } from '@flyfreely-portal-ui/loading-indicator';
import { MapModule } from '@flyfreely-portal-ui/map';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxLoadingModule } from 'ngx-loading';
import { FormatAltitudeValuePipe } from './format-altitude-value.pipe';
import { LotamDataService } from './lotam-data.service';
import { LotamDetailsDialogueComponent } from './lotam-details-dialogue/lotam-details-dialogue.component';
import { LotamDetailsComponent } from './lotam-details/lotam-details.component';
import { LotamDialoguesService } from './lotam-dialogues.service';
import { LotamEditComponent } from './lotam-edit/lotam-edit.component';
import { LotamListComponent } from './lotam-list/lotam-list.component';
import { LotamTypesSetupComponent } from './lotam-types/lotam-types-setup/lotam-types-setup.component';

@NgModule({
    imports: [
        CommonModule,
        EnhancedHelpModule,
        ValidationModule,
        FormsModule,
        AttachmentsModule,
        MapModule,
        SharedUiModule,
        ReactiveFormsModule,
        BsDatepickerModule,
        TimepickerModule,
        NgSelectModule,
        ButtonsModule,
        AnalyticsModule,
        TooltipModule,
        FlyFreelyTableModule,
        LoadingIndicatorModule,
        NgxLoadingModule,
        EditableModule,
        MatCommonModule
    ],
    declarations: [
        LotamDetailsDialogueComponent,
        LotamDetailsComponent,
        LotamEditComponent,
        LotamListComponent,
        LotamTypesSetupComponent,
        FormatAltitudeValuePipe
    ],
    exports: [
        LotamDetailsComponent,
        LotamTypesSetupComponent,
        FormatAltitudeValuePipe
    ],
    providers: [
        LotamDataService,
        LotamDialoguesService,
        FormatAltitudeValuePipe
    ]
})
export class NoticesModule {}

export { FormatAltitudeValuePipe };
